import "src/core";
import { BoundaryNames } from "src/shared/utils/sentry/BoundaryNames";
import { ViagogoAppEntrypoint } from "src/website-apps/shared/components/viagogo-app-entrypoint/viagogo-app-entrypoint";
import { App } from "./components/App";

export const VenueRoot = () => (
  <ViagogoAppEntrypoint boundaryName={BoundaryNames.VENUE}>
    <App />
  </ViagogoAppEntrypoint>
);
